<template>
  <footer class="t-footer" role="contentinfo">
    <ButtonPush
      aria-label="previous page"
      @click="pagePrevious"
      :disabled="!canPagePrevious"
      icon="icon-navwest"
      spin="icon-only inline"
      v-visible="canPagePrevious"
    />

    <div>{{ logicalPage }} of {{ lastLogicalPage }}</div>

    <ButtonPush
      aria-label="next page"
      @click="pageNext"
      :disabled="!canPageNext"
      icon="icon-naveast"
      spin="icon-only inline"
      v-visible="canPageNext"
    />
  </footer>
</template>

<style scoped lang="scss">
@import 'common';

.t-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: $footerHeight;
  overflow: hidden;
  padding: px(0.5rem) $sidebarWidth;
  z-index: map-get($zIndexes, 'footer');
  transition: bottom 0.5s ease;

  // In readmode, slide off the bottom
  .t-readmode & {
    bottom: calc(#{$footerHeight} * -1);
  }

  background-color: $footerBackgroundColor;
  font-size: $frameworkFooterFontSize;
  line-height: $frameworkFooterFontSize;

  display: flex;
  justify-content: center;
  align-items: center;

  > *:nth-child(1),
  > *:nth-child(3) {
    // Allow the buttons to grow to fill available space.
    flex: 1;
    align-self: stretch;

    // Position the icon within the button.
    display: flex;
    align-items: center;
    &:nth-child(1) {
      justify-content: flex-end;
    }
  }

  > *:nth-child(2) {
    // Set a starting (min) size on the page info to avoid shifting the
    // buttons around when the page changes to double-digits, for example.
    flex: 0 0 6em;
    text-align: center;
  }

  // Hide the button content (icon) on smaller screens, even though the button
  // is still clickable and can be tabbed to by screen readers. Its okay to
  // use display:none here instead of visibility:hidden because we're
  // affecting both buttons simultaneously, so nothing will shift around.
  // (Also we're only affecting the label in the button, not the button
  // itself.)
  //
  // Using /deep/ here means that these classes belong to another
  // component, so they shouldn't be scoped to this one.
  .lt737 & /deep/ .t-button .t-label {
    display: none;
  }
}
</style>

<script>
import ButtonPush from './ButtonPush'

export default {
  name: 'Footer',

  props: {
    canPageNext: {
      type: Boolean,
      required: true,
    },
    canPagePrevious: {
      type: Boolean,
      required: true,
    },
    lastLogicalPage: {
      type: String,
      required: true,
    },
    logicalPage: {
      type: String,
      required: true,
    },
  },

  inject: ['pageNext', 'pagePrevious'],

  components: {ButtonPush},
}
</script>
